module.exports = __webpack_public_path__ + "static/img/products5.2d5fb5bc.png";